<div>
    <mat-toolbar class="top_headerbar">
      <div class="left" [ngClass]="{ show: shouldShow, hide: !shouldShow }">
        <span *ngIf="hideItemsFromAssets" class="custom_select_outer">
          <select class="custom_select form-control width_180" #mySelect>
            <option value="0">All Sites</option>
            <option value="{{ site.id }}" *ngFor="let site of sitesList">
              {{ site.name }}
            </option>
          </select>
        </span>
        <span *ngIf="hideItemsFromAssets" class="custom_select_outer">
          <select class="custom_select form-control width_180" #groupSelect
            >
            <option value="0">All Applications</option>
            <option value="{{ group.id }}" *ngFor="let group of groupList; let idx = index">
              {{ group.name }}
            </option>
          </select>
        </span>
        <span class="custom_select_outer">
          <select class="custom_select form-control width_180" #assetsSelect>
            <option value="ALL">All Assets</option>
            <option value="OFFLINE">Offline</option>
            <option value="HEALTHY">Healthy</option>
            <option value="UNHEALTHY">Unsatisfactory</option>
            <option value="ERROR">Unacceptable</option>
          </select>
        </span>
      </div>
    </mat-toolbar>
    <div class="col-md-12">
        <div class="no_result" *ngIf="emptyMsg">
            <h4>No device added yet</h4>
        </div>
    </div>
  
</div>